import Vue from 'vue';
// 注册全局指令
import transferBlank from '../directives/transfer-blank';
import longpress from '../directives/longpress';

Vue.directive('transfer-blank', transferBlank);
Vue.directive('longpress', longpress);